<template>
  <v-main>
    <v-container fluid class="ml-3">

    <v-row dense>
        <v-col cols="12">
            <h3>Overview partner booking list</h3>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="2">
            <v-select v-model="report_params.bedr_codes" :items="bedrCodes" item-value="bedrCode"  item-text="bedrCode" label="Companies" multiple></v-select>
        </v-col>
    </v-row>
    <v-row>
        <v-col cols="2">
            <v-select v-model="report_params.inpt_codes" :items="inptCodes" item-value="inptCode"  item-text="inptOms" label="Sales partner"></v-select>
        </v-col>
    </v-row>

    <v-row>
        <v-col cols="2">
            <date_picker label="Date from"                                 
                            :date="report_params.fromDate"
                            field="fromDate" 
                            icon="mdi-calendar-month-outline"
                            :manual="false" 
                            @updateData="updateData"/> 
        </v-col>
        <v-col cols="2">
            <date_picker label="Date until"                                 
                            :date="report_params.untilDate"
                            field="untilDate" 
                            icon="mdi-calendar-month-outline"
                            :manual="false" 
                            @updateData="updateData"/>                                      
        </v-col>
    </v-row>

    <v-row>    
        <v-col cols="1">
            <btn_create_excel :report_program="report" :report_request="report_request" :report_params="report_params" :show_progress=true />
        </v-col> 
    </v-row>

  </v-container>
  <navBar title="Ares - Sales partners" :home="true" type="inpt"/>
  </v-main>
</template>

<script>

import navBar from "@/components/ui/navbars/navbar.vue";
import btn_create_excel from "@/components/ui/buttons/btn_create_excel.vue";
import date_picker from '@/components/ui/date_picker.vue';

export default {
components: {
  navBar,
  btn_create_excel,
  date_picker
},
data() {
  return {
    bedrCodes: [],
    inptCodes: [],
    report: "ares/json/ares/task/inpt/ovrz/ovrz1.p",      
    report_request: "ovrz1",   
    report_params:{
        fromDate: '',
        untilDate: '',
        bedr_codes: [],
        inpt_codes: [],            
    }
  }
},
created() {  
    this.$axios
    .post("ares/json/ares/task/inpt/ovrz/getOvrz1Param.p", {
      header: {
        token: this.$session.get("ARES"),
        clientSessionId: this.$session.id(),
        request: "getOvrz1Param"
      },
      getOvrz1Param: {}
    })
    .then(res => {
      if (res.data.error) {
        console.log(res.data.error);
      } else {
         this.bedrCodes = res.data.getOvrz1Param.bedrKeuzes;
         this.inptCodes = res.data.getOvrz1Param.inptKeuzes;
         //console.log(this.inptCodes)
         this.bedrCodes.forEach(el => {el.bedrSelected ? this.report_params.bedr_codes.push(el.bedrCode) : false});
         this.inptCodes.forEach(el => {el.inptSelected ? this.report_params.inpt_codes.push(el.inptCode) : false});
      }
    });          
},
methods: {
    updateData(data){
        this.report_params[data.field] = data.value;
    },  
}
};

</script> 




